goog.provide('el8.practicedata.uploadedImages');

goog.require('el8.service.tz');
goog.require('el8.model.base');
goog.require('el8.appservice.notifier');
goog.require('el8.practicedata.base');
goog.require('el8.data.practiceUsers');

el8.practicedata.uploadedImages = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addDateTime('receivedDate');
    _class.addStringProperty('printUrl');
    _class.addStringProperty('thumbUrl');
    _class.addStringProperty('previewUrl');
    _class.addStringProperty('organizerUrl');
    _class.addStringProperty('filerUrl');

    _class.addIntProperty('lockUserId');
    _class.addDateTime('lockTime');

    // Only exists within browser session; a display concepts
    _class.addBoolean('lockRemoved', false, false); // user override lock manually
    // Very convenient property to carry around on client
    _class.addIntProperty('fileGroupId');
    _class.addIntProperty('practiceFaxId');

    _class.prototype.asSoyMap = function() {
        var m = {};
        m['id'] = this.getId();
        m['thumbUrl'] = this.getThumbUrl();
        m['printUrl'] = this.getPrintUrl();
        m['organizerUrl'] = this.getOrganizerUrl();
        m['filerUrl'] = this.getFilerUrl();
        m['previewUrl'] = this.getPreviewUrl();
        m['lockUserId'] = this.isLocked() ? this.getLockUserId() : null;
        m['lockUserFullName'] = this.getLockUserId() ? el8.data.practiceUsers.getById(this.getLockUserId()).getFullName() : '';
        m['lockTime'] = this.isLocked() ? el8.service.tz.soyStr(this.getLockTime()) : null;
        m['receivedDate'] = el8.service.tz.soyStr(this.getReceivedDate());
        m['isLockRemoved'] = this.isLockRemoved();
        return m;
    };
    _class.prototype.isLocked = function() {
        return this.getLockUserId() && this.getLockTime();
    };
    _class.prototype.isSelectable = function() {
        return (this.isLockRemoved() || !this.isLocked());
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) { return el8.service.urls.get('uploadedImage', [id]); },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('unfiledDocument', [item.getId()]),
                async: opts.async,
                success: successCb,
                error: errorCb
            });
        }
    });

    var super_remove = that.remove;
    that.remove = function(item, noNotify) {
        var itemId = (typeof(item) === 'object') ? item.getId() : item;
        super_remove.apply(that, arguments);
        // Rip through all the incomingFaxes and remove this image id as needed
        var allFileGroups = el8.practicedata.incomingFileGroups.all();
        for (var i=0; i<allFileGroups.length; i++) {
            var removed = allFileGroups[i].removeImageId(itemId);
            if (removed) { return; }
        }
    };

    that.restoreItem = function(spec) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('restoreUnfiledDocument', [spec.id]),
            success: spec.successCb,
            error: spec.errorCb,
            error_override: spec.errorOverrideCb
        });
    };

    that.rotateImage = function(spec) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('rotateUnfiledDocument', [spec.id]),
            data: JSON.stringify({ direction: spec.direction, size: spec.size }),
            success: function(data) {
                that.create(data);
                if (spec.successCb) { spec.successCb(data); }
            },
            error: spec.errorCb,
            error_override: spec.errorOverrideCb
        });
    };

    that.printImages = function(idList) {
        window.open(el8.service.urls.get('printUnfiledDocuments', [idList]));
    };

    that.markLocked = function(item, opts) {
        opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            async: opts.async,
            url: el8.service.urls.get('lockUnfiledDocument', [item.getId()]),
            success: function(data) {
                item.populate(data);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };

    that.markUnlocked = function(item, opts) {
        opts = opts || {};
        $.el8_ajax({
            type: 'DELETE',
            async: opts.async,
            url: el8.service.urls.get('lockUnfiledDocument', [item.getId()]),
            success: function(data) {
                item.setLockUserId(null);
                item.setLockTime(null);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };

    return that;

})();

